var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen flex flex-col"},[_c('common-nav',{attrs:{"show-cart":true}}),_c('div',{staticClass:"flex-grow"},[_c('router-view')],1),_c('footer-outfitter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }